<ate-modal has-cta="false" has-close-icon="true" #ateModal is-native="false" (onModalClose)="onNativeModalClose()">
  <h3 slot="header">Exclude from Leads</h3>
  <div slot="body">
    <p class="tw-text-sm">Choose how you want to filter these emails from your Leads inbox.</p>
    <div class="tw-flex tw-flex-col tw-gap-4 tw-text-left">
      <div
        class="tw-group tw-flex tw-cursor-pointer tw-items-center tw-gap-4 tw-rounded-md tw-border tw-border-solid tw-border-slate-300 tw-bg-white tw-p-4 hover:tw-border-brand-maroon/40 hover:tw-bg-brand-maroon/5"
        (click)="select('thread')">
        <div
          class="tw-brand-maroon/40 tw-flex tw-size-[48px] tw-min-w-0 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-md tw-bg-brand-maroon/5 tw-text-brand-maroon group-hover:tw-bg-gradient-to-r group-hover:tw-from-brand-gradientfrom group-hover:tw-to-brand-gradientto group-hover:tw-text-brand-contrast">
          <ate-icon name="ate-email-cross" class="tw-size-5"></ate-icon>
        </div>
        <div>
          <div class="tw-mb-1 tw-font-bold">Exclude this thread</div>
          <div class="tw-text-sm tw-text-slate-600">Remove only this email thread from your Leads inbox</div>
        </div>
      </div>
      @if (fromEmail) {
        <div
          class="tw-group tw-flex tw-cursor-pointer tw-items-center tw-gap-4 tw-rounded-md tw-border tw-border-solid tw-border-slate-300 tw-bg-white tw-p-4 hover:tw-border-brand-maroon/40 hover:tw-bg-brand-maroon/5"
          (click)="select('address')">
          <div
            class="tw-brand-maroon/40 tw-flex tw-size-[48px] tw-min-w-0 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-md tw-bg-brand-maroon/5 tw-text-brand-maroon group-hover:tw-bg-gradient-to-r group-hover:tw-from-brand-gradientfrom group-hover:tw-to-brand-gradientto group-hover:tw-text-brand-contrast">
            <ate-icon name="ate-person-cross" class="tw-size-5"></ate-icon>
          </div>
          <div>
            <div class="tw-mb-1 tw-font-bold">Exclude sender email address</div>
            <div class="tw-text-sm tw-text-slate-600">
              Exclude all emails from <strong>{{ fromEmail }}</strong>
            </div>
          </div>
        </div>
        @if (!popularIsp) {
          <div
            class="tw-group tw-flex tw-cursor-pointer tw-items-center tw-gap-4 tw-rounded-md tw-border tw-border-solid tw-border-slate-300 tw-bg-white tw-p-4 hover:tw-border-brand-maroon/40 hover:tw-bg-brand-maroon/5"
            (click)="select('domain')">
            <div
              class="tw-brand-maroon/40 tw-flex tw-size-[48px] tw-min-w-0 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-md tw-bg-brand-maroon/5 tw-text-brand-maroon group-hover:tw-bg-gradient-to-r group-hover:tw-from-brand-gradientfrom group-hover:tw-to-brand-gradientto group-hover:tw-text-brand-contrast">
              <ate-icon name="ate-website-v2" class="tw-size-5"></ate-icon>
            </div>
            <div>
              <div class="tw-mb-1 tw-font-bold">Exclude sender email domain</div>
              <div class="tw-text-sm tw-text-slate-600">
                Exclude all emails from <strong>{{ getDomain(fromEmail) }}</strong>
              </div>
            </div>
          </div>
        }
      }
    </div>
  </div>
</ate-modal>
